import { PureComponent } from 'react';

import ProductListQuery from 'Query/ProductList.query';
import { Field } from 'Util/Query';

/** @namespace Pwa/Query/AutoRelated/Query */
export class AutoRelated extends PureComponent {
    getProductPageAutoRelated(uid, position) {
        const query = new Field('amMostviewedGroups')
            .addArgument('uid', 'String!', uid)
            .addArgument('position', 'String!', position)
            .addField(this._getAutoRelatedItemField());

        return query;
    }

    _getAutoRelatedItemField() {
        return new Field('items').addFieldList(['block_title', ProductListQuery._getItemsField()]);
    }
}

export default new AutoRelated();
